import { removeConnectionsHavingUnmatch } from '../../utils/functions'

export default {
  install(editor, options) {
    editor.on('connectioncreated', (connection) => {
      const node = connection.output.node
      if (options.name && (options.name === node.name)) {
        if (options.name && options.havingUnmatch && Array.isArray(options.havingUnmatch)) {
          removeConnectionsHavingUnmatch(node, options.havingUnmatch, connection.output.key)
        }
      }
    })
  }
}